import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Geolocation } from '@capacitor/geolocation';
import { Coordinate, Kecamatan, Kota, Provinsi } from '../interfaces/location';
import { openLinkNewTab } from 'src/helpers';
import { HttpClient } from '@angular/common/http';
import * as ApiLocation from '../interfaces/api/location';
import { BaseService } from './base.service';
import { map as rsjxMap, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocationService extends BaseService {
  private apiWilayah = 'https://api.binderbyte.com/wilayah';
  private api_key_wilayah = '44275844973c8b9bb450801e07cbe4bcb53b86755da1dd21f77cce72518f5d69';

  constructor(private http: HttpClient) {
    super();
  }

  async useCurrentLocation(): Promise<Coordinate> {
    if (!Capacitor.isPluginAvailable('Geolocation')) {
      // await this.presentGeolocationErrorAlert();
      console.log('permission location denied');
      return;
    }

    try {
      const position = await Geolocation.getCurrentPosition({
        enableHighAccuracy: true,
      });

      // this.createLocation(position.coords.latitude, position.coords.longitude);
      return {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };
    } catch (error) {
      // await this.presentGeolocationErrorAlert();
      console.log('permission location denied on catch');
    }
  }

  routeMaps(from: Coordinate, to: Coordinate, data: any) {
    const from_string = `${from.latitude},${from.longitude}`;
    const to_string = `${to.latitude},${to.longitude}`;
    // const url = new URL(`https://www.google.com/maps/dir/'${from_string}'/'${to_string}'`);
    // openLinkNewTab(url.href);
    if (data.maps_url) {
      const url = new URL(`${data.maps_url}`);
      openLinkNewTab(url.href);
    } else {
      if (data.placeid) {
        const url = new URL(
          `https://www.google.com/maps/search/?api=1&query=${data.latitude},${data.longitude}&query_place_id=${data.placeid}`,
        );
        openLinkNewTab(url.href);
      } else {
        const url = new URL(`https://www.google.com/maps/search/?api=1&query=${data.latitude},${data.longitude}`);
        openLinkNewTab(url.href);
      }
    }
  }

  getProvince(): Observable<{ value: Provinsi[] }> {
    const url = new URL(`${this.apiUrl}/province`);

    return this.http.get<ApiLocation.GetProvinsiResponse>(url.href).pipe(
      rsjxMap(data => ({
        value: data.provinces.map(p => ({ id: p.code.toString(), name: p.name })),
      })),
    );
  }

  getCities(id_provinsi: string): Observable<{ value: Kota[] }> {
    const url = new URL(`${this.apiUrl}/city`);
    url.searchParams.set('province_id', id_provinsi);

    return this.http.get<ApiLocation.GetCitiesResponse>(url.href).pipe(
      rsjxMap(data => ({
        value: data.cities.map(c => ({ id: c.code.toString(), name: c.name, id_provinsi: c.provinsiId.toString() })),
      })),
    );
  }

  getKecamatan(id_city: string): Observable<{ value: Kecamatan[] }> {
    const url = new URL(`${this.apiUrl}/kecamatan`);
    url.searchParams.set('city_id', id_city);

    return this.http.get<ApiLocation.GetKecamatanResponse>(url.href).pipe(
      rsjxMap(data => ({
        value: data.district.map(d => ({ id: d.code.toString(), name: d.name, id_kabupaten: null })),
      })),
    );
  }
}
